module.exports = __webpack_public_path__ + "media/images/pages/a-level/i_c_s-e65cf1aca48371b05818616ed281a538.svg";